export const ADICIONAR_MENSAGEM = "mensagem/ADICIONAR_MENSAGEM";
export const FECHAR_MENSAGEM = "mensagem/FECHAR_MENSAGEM";

export const exibirMensagem = mensagem => dispatch => {
  dispatch({ type: ADICIONAR_MENSAGEM, mensagem });
}

export const fecharMensagem = () => dispatch => {
  dispatch({ type: FECHAR_MENSAGEM });
}

export const exibirErros = erros => dispatch => {

  // Trata array de response
  if (Array.isArray(erros)) {
    return erros
      .filter(({ ok }) => !ok)
      .map(erro => dispatch(exibirErros(erro)));
  }

  if (typeof erros === 'string' || erros instanceof String) {
    return dispatch(exibirMensagem({ msg: erros, tipo: "error" }));
  }

  const { status = "", message = "" } = erros;

  if (/400/.test(status)) {
    return dispatch(exibirMensagem({ msg: "Nenhum registro encontrado.", tipo: "info" }));
  }

  if (erros.json) {
    return erros.json()
      .then(erroJson => {

        if (Array.isArray(erroJson)) {
          return erroJson.map(({ error: erro, error_description: detalhes }) => {
            dispatch(exibirMensagem({ msg: erro, tipo: "error" }));
            return detalhes ? detalhes.map(detalhe => dispatch(exibirMensagem({ msg: detalhe, tipo: "warning" }))) : "";
          });
        }

        const { msg, code, details, message, debug } = erroJson;
        if (message) {
          return dispatch(exibirMensagem({ msg: message, tipo: "error" }));
        }

        dispatch(exibirMensagem({ msg: `${msg ? msg : "Erro inesperado"}${code ? `. Código: ${code}` : ""}${debug ? `. Debug: ${debug}` : ""}`, tipo: "error" }));
        return details ? details.map(detalhe => dispatch(exibirMensagem({ msg: detalhe, tipo: "warning" }))) : "";
      })
      .catch(erros => dispatch(exibirErros(erros)));
  }

  if (message) {
    return dispatch(exibirMensagem({ msg: message, tipo: "error" }));
  }

  return dispatch(exibirMensagem({ msg: `Erro inesperado. ${status ? `Código: ${status}` : ""}`, tipo: "error" }));
}


// WEBPACK FOOTER //
// ./src/componentes/mensagem/actions.js